const config = {
  secureMessagingApi: {
    host: import.meta.env.VITE_API_HOST,
  },
  customerComponent: {
    host: import.meta.env.VITE_CUSTOMER_COMPONENT_HOST,
  },
  cultureCodes: {
    danish: "da-DK",
    english: "en-GB",
    finnish: "fi-FI",
    finnishSwedish: "sv-FI",
    swedish: "sv-SE",
    norwegian: "nb-NO",
  },
  messageSubjectCategories: {
    danish: {
      personalClaims: "Skade på dig selv eller en anden person",
      motorClaims: "Skade på eller med Motorkøretøj",
      propertyClaims: "Skade på hus, indbo, eller dyr",
      travelClaims: "Skade på rejse",
    },
  },
  attachments: {
    uploadCancelledByUserException: "Upload cancelled by user.",
    maxSize: 104857600,
    allowedFileTypes: [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
      "text/plain",
      "application/rtf",
      "image/tiff",
      "image/gif",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/heic",
      "image/heif",
      "video/mp4",
    ],
    allowedFileExtensions: [
      ".xls",
      ".xlsx",
      ".ppt",
      ".pptx",
      ".doc",
      ".docx",
      ".pdf",
      ".txt",
      ".rtf",
      ".tif",
      ".tiff",
      ".gif",
      ".jpeg",
      ".jpg",
      ".png",
      ".heic",
      ".heif",
      ".mp4",
    ],
  },
};

export default config;
